import React, { ReactNode } from "react";

export default function NotAuthorized({ children }: { children: ReactNode }) {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
      }}
    >
      <img src={"https://www.marcobehler.com/images/guides/undraw_security_o890-526cc2fb.svg"} style={{ maxWidth: 375, height: "auto", marginBottom: 20 }} />
      {children}
    </div>
  );
}
